/**
 * @file TickCheckbox.js
 * @version 1.0.1
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-04-23
 * @modified 2026-04-23
 */

import React from 'react';

function TickCheckbox({
  id,
  checked,
  onChange,
  disabled = false,
  onMouseDown,
  onMouseEnter,
  size = 16,
  style,
  className = '',
  label,
  ariaLabel,
  title,
}) {
  const wrapperStyle = label
    ? style
    : { justifyContent: 'center', gap: '0', ...(style || {}) };

  // When drag-select is wired up (onMouseDown provided), the toggle is applied
  // during mousedown. Suppress the label's default click-dispatches-to-input
  // behaviour so the subsequent onChange doesn't double-toggle.
  const handleClick = onMouseDown ? (e) => e.preventDefault() : undefined;

  return (
    <label
      className={`tick-check-label ${className}`.trim()}
      style={wrapperStyle}
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
      onClick={handleClick}
      title={title}
    >
      <input
        type="checkbox"
        className="tick-check-input"
        id={id}
        checked={!!checked}
        onChange={onChange || (() => {})}
        disabled={disabled}
        aria-label={ariaLabel}
      />
      <label htmlFor={id} className="tick-check">
        <svg width={`${size}px`} height={`${size}px`} viewBox="0 0 18 18">
          <path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z" />
          <polyline points="1 9 7 14 15 4" />
        </svg>
      </label>
      {label && <span>{label}</span>}
    </label>
  );
}

export default TickCheckbox;
